import { render } from "./NewsletterOptOut.vue?vue&type=template&id=81424144&scoped=true"
import script from "./NewsletterOptOut.vue?vue&type=script&lang=js"
export * from "./NewsletterOptOut.vue?vue&type=script&lang=js"

import "./NewsletterOptOut.vue?vue&type=style&index=0&id=81424144&scoped=true&lang=css"

import exportComponent from "/Users/derem1991/workspace/newear/frontend/kajot/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81424144"]])

export default __exports__